import { buildBrandPath } from "../utils/productLinks";

export const getBrandPath = buildBrandPath;

export const getBrandFallbackText = (brandName) => {
  const words = brandName.match(/[A-Za-z0-9]+/g) ?? [];
  const initials = words
    .slice(0, 3)
    .map((word) => word[0])
    .join("")
    .toUpperCase();

  return initials || brandName.slice(0, 2).toUpperCase();
};
